// @flow
export default function asInt (value: mixed): ?any {
  const n = Number(value)

  if (isNaN(n)) {
    return null
  }

  return Math.round(n)
}
